window.Aedu.Auth.EmailSignupController = function () {
  function EmailSignupController(options) {
    this.track = options.track;
    this.init_elements(options.elements);
    this.init_provided_fields(options.fields);
    this.notifier = new c.Server.Notification('sutd');
    this.recaptchaListeners = options.recaptchaListeners;
    this.init_form();
  }
  EmailSignupController.prototype.init_elements = function (elements) {
    this.elements = {};
    _.each(elements, function (_this) {
      return function (selector, name) {
        return _this.elements[name] = $(selector);
      };
    }(this));
    return this.elements.submit = this.elements.form.find('[type=submit]');
  };
  EmailSignupController.prototype.init_provided_fields = function (fields) {
    return _.each(fields, function (_this) {
      return function (val, selector) {
        var sel;
        sel = $(selector);
        if (val != null) {
          sel.val(val);
        }
        if (_this.track) {
          return sel.on('keypress.tracker', function (event) {
            sel.off('keypress.tracker');
            return _this.notifier.notify({
              event_type: "started_typing",
              location: event.target.id,
              auvid: $auvid,
              hit_id: window.Aedu && Aedu.hit_data && Aedu.hit_data.id || null
            });
          });
        }
      };
    }(this));
  };
  EmailSignupController.prototype.init_form = function () {
    this.elements.form.on('submit', function (_this) {
      return function (e) {
        return _this.handle_submission(e);
      };
    }(this));
    return this.recaptchaListeners.push(function (_this) {
      return function (code) {
        return _this.handle_submission(code);
      };
    }(this));
  };
  EmailSignupController.prototype.submit_url = function () {
    var url;
    return url = this.elements.form.attr('action');
  };
  EmailSignupController.prototype.handle_submission = function (event) {
    var params;
    if (this.submitting) {
      return;
    }
    this.disable_submit();
    if (this.track) {
      this.notifier.notify({
        event_type: 'attempted_submit',
        auvid: $auvid,
        hit_id: window.Aedu && Aedu.hit_data && Aedu.hit_data.id || null
      });
    }
    params = this.elements.form.serializeObject();
    params.user_source = UserSource.last();
    $.ajax({
      type: 'POST',
      url: this.submit_url(),
      data: params,
      dataType: 'json',
      xhrFields: {
        withCredentials: true
      }
    }).always(function (_this) {
      return function () {
        _this.elements.spinner.hide();
        return _this.enable_submit();
      };
    }(this)).done(function (_this) {
      return function (raw_data) {
        var data, errors, ok;
        ok = raw_data[0], data = raw_data[1], errors = raw_data[2];
        if (ok) {
          return _this.redirect_on_success(data.redirect);
        } else {
          return _this.handle_validation_errors(errors);
        }
      };
    }(this)).fail(function (_this) {
      return function () {
        return alert("Oops... Something just went wrong! We're taking a look at the issue right now. Please try again in a few minutes.");
      };
    }(this));
    this.elements.spinner.show();
    return false;
  };
  EmailSignupController.prototype.disable_submit = function () {
    this.submitting = true;
    return this.elements.submit.attr('disabled', true);
  };
  EmailSignupController.prototype.enable_submit = function () {
    this.submitting = false;
    return this.elements.submit.attr('disabled', false);
  };
  EmailSignupController.prototype.redirect_on_success = function (target) {
    if (target == null) {
      target = '/StartRegPath';
    }
    return window.parent.location.href = target;
  };
  EmailSignupController.prototype.handle_validation_errors = function (errors) {
    this.displayErrors(errors);
    $(document).trigger("set_iframe_size");
    return this.notifier.notify({
      event_type: 'validation_failure',
      error: JSON.stringify(errors),
      auvid: $auvid,
      hit_id: window.Aedu && Aedu.hit_data && Aedu.hit_data.id || null
    });
  };
  EmailSignupController.prototype.renderErrorHTML = function (message) {
    return "<div class='js-signup-input-inner-error signup-input-inner-error u-tcRed a-fadeInDownShort u-fs11'>" + message + "</div>";
  };
  EmailSignupController.prototype.displayErrors = function (errors) {
    var $email, $firstName, $inputs, $lastName, $password;
    $email = $('[name="user[email]"]');
    $firstName = $('[name="user[first_name]"]');
    $lastName = $('[name="user[last_name]"]');
    $password = $('[name="user[password]"]');
    $inputs = $email.add($firstName).add($lastName).add($password);
    $inputs.removeClass("TextInput--error").addClass("TextInput--dark").css({
      'padding-top': 0
    });
    $(".js-signup-input-inner-error").remove();
    return _.each(errors, function (_this) {
      return function (error) {
        var message, property;
        property = error[0], message = error[1];
        if (property === 'user[email]') {
          _this.showErrorForInput($email, message);
        }
        if (property === 'user[first_name]') {
          _this.showErrorForInput($firstName, message);
        }
        if (property === 'user[last_name]') {
          _this.showErrorForInput($lastName, message);
        }
        if (property === 'user[password]') {
          return _this.showErrorForInput($password, message);
        }
      };
    }(this));
  };
  EmailSignupController.prototype.showErrorForInput = function ($input, message) {
    return $input.addClass("TextInput--error").removeClass("TextInput--dark").after(this.renderErrorHTML(message.replace(/\.$/g, ""))).css({
      'padding-top': 10
    });
  };
  return EmailSignupController;
}();